import GetReminderResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/ReminderService/GetReminderResponse";
import ReminderCreateRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/ReminderService/ReminderCreateRequest";
import ReminderUpdateRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/ReminderService/ReminderUpdateRequest";
import ReminderTranslateModel from "./reminderTranslateModel";

export default class CreateReminderViewModel {
    id?: number = null;
	translations: Array<ReminderTranslateModel> = null;
    initLanguages(langs: string[]) {
        this.translations = (langs || []).map(x => new ReminderTranslateModel({
            langCode: x
        }));
    }
	getTranslations() {
		return (this.translations || [])
			.filter((x) => (x.title || '').trim() && (x.text || '').trim())
			.map((x) => x.toServerModel());
	}
	toCreateServerModel(): ReminderCreateRequest {
		return new ReminderCreateRequest({
			Translations: this.getTranslations()
		});
	}
	toServerModel(): ReminderUpdateRequest {
		const translations = this.getTranslations();

		const req = new ReminderUpdateRequest({
			ReminderId: this.id || 0,
			Translations: translations
		});
		
		return req;
	}
	fromServerModel(model: GetReminderResponse) {
		this.id = model.Id;
		this.translations.forEach(tr => {
			const serverTranslation = model.Translations.find(x=>x.LangCode == tr.langCode);
			if (serverTranslation != null) {
				tr.text = serverTranslation.Text;
				tr.title = serverTranslation.Title;
			}
		});
	}
}
